import { render, staticRenderFns } from "./JsonListDisplay.vue?vue&type=template&id=5ce30973&scoped=true&"
import script from "./JsonListDisplay.vue?vue&type=script&lang=js&"
export * from "./JsonListDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce30973",
  null
  
)

export default component.exports